// gatsby-browser.js
import "@fontsource/outfit/400.css"; // Regular weight
import "@fontsource/outfit/500.css"; // Medium weight
import "@fontsource/outfit/600.css"; // Semi-Bold weight
import "@fontsource/outfit/700.css"; // Bold weight

// A9 (2026-07-17): the washer-portal SCSS declares these families but they
// were never bundled, so the portal silently fell back to system fonts.
import "@fontsource/inter-tight/400.css";
import "@fontsource/inter-tight/500.css";
import "@fontsource/inter-tight/600.css";
import "@fontsource/inter-tight/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import "@fontsource/baloo-2/600.css";
import "@fontsource/baloo-2/700.css";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
// The Washer Hero training (2026-07-25) uses Baloo 2 at 800 for 45 of its 63
// display headings and Nunito at 500/800. Without the real 800 faces the
// browser synthesises bold, which looks like a rendering bug rather than a
// missing font — and it is easy to miss because everything still lays out.
import "@fontsource/baloo-2/800.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/800.css";

import "firebase/auth";
import "firebase/firestore";
import Modal from "react-modal";
import ReactDOM from "react-dom";

import wrapWithProvider from "./wrap-with-provider";
import browserHydrateFunction from "./src/utils/browser-hydrate-functions";
import {initAnalyticsIfConsented, syncTawkForRoute} from "./src/utils/analyticsConsent";
import {captureAttribution} from "./src/utils/attribution";
export const wrapRootElement = wrapWithProvider;

export const onClientEntry = () => {
  Modal.setAppElement("#___gatsby");
  // First-party attribution cookie — runs regardless of the consent choice.
  captureAttribution();
  initAnalyticsIfConsented();
  
  // Patch ReactDOM.unmountComponentAtNode for React 18 compatibility
  // This fixes warnings from Gatsby's head-export-handler which uses the old API
  if (typeof window !== 'undefined' && ReactDOM && ReactDOM.unmountComponentAtNode) {
    const originalUnmount = ReactDOM.unmountComponentAtNode;
    ReactDOM.unmountComponentAtNode = function(container) {
      // If container has a root (from createRoot), use root.unmount() instead
      if (container && container._reactRootContainer && container._reactRootContainer.unmount) {
        container._reactRootContainer.unmount();
        delete container._reactRootContainer;
      } else {
        // Fallback to original for containers without our root
        originalUnmount.call(this, container);
      }
    };
  }
};

/**
 * W-01 / P4-07 · per-route tawk.to rules.
 *
 * onClientEntry fires once per full page load; this site is an SPA after that,
 * so without a route hook the tawk widget keeps whatever state the FIRST page
 * left it in. That is how the widget ended up covering the training's "Progress"
 * tab: a visitor who landed on a marketing page picked up the bubble and carried
 * it into /washer/app/step/training/, where the portal has its own support chat
 * and tawk's z-index 99 outranks everything the training draws.
 *
 * syncTawkForRoute hides it inside the portal, restores it outside, and
 * minimizes the mobile panel on navigation. See the notes in analyticsConsent.js
 * for what is and is not fixable from this repo.
 */
export const onRouteUpdate = ({location}) => {
  syncTawkForRoute(location?.pathname);
};

export const replaceHydrateFunction = browserHydrateFunction;
